<template>
  <div class="basicPortContent">
    <Breadcrumb :matched="matched" />
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="网站查询" name="webSiteDate">
        <webSite v-if="webSiteDate" />
      </el-tab-pane>
      <el-tab-pane label="航线信息" name="routeInfor">
        <routeInfor v-if="routeInfor" />
      </el-tab-pane>
      <el-tab-pane label="港到港实时船期" name="portToPort">
        <portToPort v-if="portToPort" />
      </el-tab-pane>
      <el-tab-pane label="航线船名航次" name="nameRoute">
        <nameRoute v-if="nameRoute" />
      </el-tab-pane>
      <el-tab-pane label="船名查询" name="nameQuery">
        <nameQuery v-if="nameQuery" />
      </el-tab-pane>
      <el-tab-pane label="航线挂靠港预计日期" name="estimatDate">
        <estimatDate v-if="estimatDate" />
      </el-tab-pane>
      <el-tab-pane label="港口五字码" name="fiveCode">
        <fiveCode v-if="fiveCode" />
      </el-tab-pane>
      <el-tab-pane label="新港到港实时船期" name="newPortToPort">
        <newPortToPort v-if="newPortToPort" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb/Breadcrumb.vue'
import webSite from './webSite.vue'
import routeInfor from './routeInfor.vue'
import portToPort from './portToPort.vue'
import nameRoute from './nameRoute.vue'
import nameQuery from './nameQuery.vue'
import estimatDate from './estimatDate.vue'
import fiveCode from './fiveCode.vue'
import newPortToPort from './newPortToPort.vue'
export default {
  inject: ['reload'],
  components: {
    Breadcrumb,
    webSite,
    routeInfor,
    portToPort,
    nameRoute,
    nameQuery,
    estimatDate,
    fiveCode,
    newPortToPort,
  },
  data() {
    return {
      matched: '',
      activeName: 'webSiteDate',
      webSiteDate: true,
      routeInfor: false,
      portToPort: false,
      nameRoute: false,
      nameQuery: false,
      estimatDate: false,
      fiveCode: false,
      newPortToPort: false,
    }
  },
  mounted() {
    this.reload()
    this.matched = this.$route.matched
  },
  methods: {
    handleClick(tab, event) {
      if (tab.label == '网站查询') {
        this.webSiteDate = true
        this.routeInfor = false
        this.portToPort = false
        this.nameRoute = false
        this.nameQuery = false
        this.estimatDate = false
        this.fiveCode = false
        this.newPortToPort = false
      } else if (tab.label == '航线信息') {
        this.webSiteDate = false
        this.routeInfor = true
        this.portToPort = false
        this.nameRoute = false
        this.nameQuery = false
        this.estimatDate = false
        this.fiveCode = false
        this.newPortToPort = false
      } else if (tab.label == '港到港实时船期') {
        this.webSiteDate = false
        this.routeInfor = false
        this.portToPort = true
        this.nameRoute = false
        this.nameQuery = false
        this.estimatDate = false
        this.fiveCode = false
        this.newPortToPort = false
      } else if (tab.label == '航线船名航次') {
        this.webSiteDate = false
        this.routeInfor = false
        this.portToPort = false
        this.nameRoute = true
        this.nameQuery = false
        this.estimatDate = false
        this.fiveCode = false
        this.newPortToPort = false
      } else if (tab.label == '船名查询') {
        this.webSiteDate = false
        this.routeInfor = false
        this.portToPort = false
        this.nameRoute = false
        this.nameQuery = true
        this.estimatDate = false
        this.fiveCode = false
        this.newPortToPort = false
      } else if (tab.label == '航线挂靠港预计日期') {
        this.webSiteDate = false
        this.routeInfor = false
        this.portToPort = false
        this.nameRoute = false
        this.nameQuery = false
        this.estimatDate = true
        this.fiveCode = false
        this.newPortToPort = false
      } else if (tab.label == '港口五字码') {
        this.webSiteDate = false
        this.routeInfor = false
        this.portToPort = false
        this.nameRoute = false
        this.nameQuery = false
        this.estimatDate = false
        this.fiveCode = true
        this.newPortToPort = false
      } else if (tab.label == '新港到港实时船期') {
        this.webSiteDate = false
        this.routeInfor = false
        this.portToPort = false
        this.nameRoute = false
        this.nameQuery = false
        this.estimatDate = false
        this.fiveCode = false
        this.newPortToPort = true
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.basicPortContent {
  padding: 20px 20px 0px 20px;
  .el-tabs {
    background-color: #fff;
    padding: 10px 0px 20px 0px;
  }
  ::v-deep.el-tabs__item.is-active {
    color: #333;
    font-weight: bold;
  }
  ::v-deep.el-tabs__item:hover {
    color: #333;
  }
  ::v-deep.el-tabs__item {
    font-size: 13px;
  }
  ::v-deep.el-tabs__nav-scroll {
    padding-left: 20px;
  }
}
</style>
